module.exports = __webpack_public_path__ + "static/media/HolyCrossNewsletterApril2024.0306e4c7.pdf";